/* eslint-disable unicorn/prefer-module */
/* eslint-disable max-len */
/* eslint-disable prettier/prettier */
/* eslint-disable no-console */
import React, { useCallback, useEffect, useMemo, useState } from "react";
import Button from "react-bootstrap/Button";
import Dropdown from "react-bootstrap/Dropdown";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import toast from "react-hot-toast";
import { FaEdit } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { Loader } from "..";
import { useAuthContext } from "../../context/auth";
import { getOportunidades, getOportunidadesBTL, getIntermediarios, getClientes, updateOportunidad, updateOportunidadBTL, log, getUsers } from "../../utils";
import "./stylesVentasFacturas.scss";

export const VentasFacturas = () => {
  const [todasOportunidades, setTodasOportunidades] = useState([]);
  const [oportunidadesFiltradas, setOportunidadesFiltradas] = useState([]);
  const [intermediarios, setIntermediarios] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [filtroNumeroFactura, setFiltroNumeroFactura] = useState("");
  const [filtroCliente, setFiltroCliente] = useState("");
  const [filtroCobrada, setFiltroCobrada] = useState("");
  const [numerosFacturaUnicos, setNumerosFacturaUnicos] = useState([]);
  const [clientesUnicos, setClientesUnicos] = useState([]);
  const [filtroAnos, setFiltroAnos] = useState([new Date().getFullYear().toString()]);
  const [filtroMeses, setFiltroMeses] = useState([]);
  const [filtroTipo, setFiltroTipo] = useState("");
  const [filtroIntermediario, setFiltroIntermediario] = useState("");
  const [filtroFacturado, setFiltroFacturado] = useState("");
  const [intermediariosUnicos, setIntermediariosUnicos] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [oportunidadEditada, setOportunidadEditada] = useState(null);
  const [formData, setFormData] = useState({
    facturanumero: "",
    facturafecha: "",
    plazocobro: "",
    facturafechacobro: "",
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [usuarios, setUsuarios] = useState([]);
  const [filtroEjecutivo, setFiltroEjecutivo] = useState("");
  const [ejecutivosUnicos, setEjecutivosUnicos] = useState([]);
  const possibleYears = ["2024", "2025", "2026", "2027"];
  const { pais } = useAuthContext();
  const navigate = useNavigate();

  const logo = useMemo(
    () =>
      ({
        Chile: require("../../img/wecast-logo.png"),
        Perú: require("../../img/visiona-logo.png"),
        Uruguay: require("../../img/screenmedia-logo.png"),
        Region: require("../../img/adigital-logo.png"),
      })[pais] || require("../../img/visiona-logo.png"),
    [pais]
  );
  const localString = useCallback(
    (pais) =>
      ({
        Chile: "es-CL",
        Perú: "es-PE",
        Uruguay: "es-UY",
      })[pais] || "es-UY",
    []
  );
  const moneda = useCallback(
    (pais) =>
      ({
        Chile: "$",
        Perú: "S/",
        Uruguay: "$",
      })[pais] || "$",
    []
  );
  const decimales = useCallback(
    (pais) =>
      ({
        Chile: 0,
        Perú: 2,
        Uruguay: 0,
      })[pais] || 0,
    []
  );
  const tiposDeCambio = {
    Uruguay: 40,
    Perú: 3.75,
    Chile: 950,
  };
  const getImporteConvertido = useCallback((importe, pais, moneda_dolar, facturafecha) => {
    if (!moneda_dolar || !importe) return importe || 0;
    const tipoCambio = tiposDeCambio[pais] || 1;
    // TODO: En el futuro, integrar una API de tipos de cambio (ej. ExchangeRate-API) para obtener el tipo de cambio dinámico basado en facturafecha
    return importe * tipoCambio;
  }, []);
  const mesEnLetras = useCallback((mes) => {
    const mesesEnLetras = ["ENE", "FEB", "MAR", "ABR", "MAY", "JUN", "JUL", "AGO", "SEP", "OCT", "NOV", "DIC"];
    return mesesEnLetras[parseInt(mes, 10) - 1] || "";
  }, []);
  const resolverNombreIntermediario = useCallback((intermediarioId, intermediarios) => {
    if (!intermediarioId) return "SIN INTERMEDIARIO";
    const intermediarioAsociado = intermediarios.find(
      (i) => i.id === parseInt(intermediarioId)
    );
    return intermediarioAsociado ? intermediarioAsociado.nombre : "SIN INTERMEDIARIO";
  }, []);

  useEffect(() => {
    const initialize = async () => {
      try {
        const [allOportunidades, allIntermediarios, allClientes, allUsuarios] = await Promise.all([
          getOportunidades({ pais }),
          getIntermediarios({ pais }),
          getClientes({ pais }),
          getUsers(),
        ]);
        const allOportunidadesBTLPromises = possibleYears.map(ano => getOportunidadesBTL({ pais, ano }));
        const allOportunidadesBTLArrays = await Promise.all(allOportunidadesBTLPromises);
        const allOportunidadesBTL = allOportunidadesBTLArrays.flat();

        // Deduplicate BTL opportunities by ID
        const seenIds = new Set();
        const uniqueOportunidadesBTL = allOportunidadesBTL.filter((btl) => {
          if (seenIds.has(btl.id)) {
            return false;
          }
          seenIds.add(btl.id);
          return true;
        });

        // Mapear oportunidades regulares con el campo ejecutivo
        const mappedOportunidades = allOportunidades.map((op) => {
          let mes = (new Date().getMonth() + 1).toString().padStart(2, "0");
          let ano = new Date().getFullYear().toString();
          if (op.mes_factura && typeof op.mes_factura === "string") {
            const [month, year] = op.mes_factura.split("-");
            if (month && year) {
              mes = month.padStart(2, "0");
              ano = year;
            }
          }
          return {
            ...op,
            ejecutivo: op.ejecutivo ? parseInt(op.ejecutivo, 10) : null,
            mes,
            ano,
          };
        });

        // Mapear oportunidades BTL con executive_responsible
        const filteredOportunidadesBTL = uniqueOportunidadesBTL.filter(
          (btl) => btl.status === 100 && !btl.eliminada && btl.pais === pais
        );
        const mappedOportunidadesBTL = filteredOportunidadesBTL.map((btl) => {
          let mes = (new Date().getMonth() + 1).toString().padStart(2, "0");
          let ano = new Date().getFullYear().toString();
          if (btl.mes_factura && typeof btl.mes_factura === "string") {
            const [month, year] = btl.mes_factura.split("-");
            if (month && year) {
              mes = month.padStart(2, "0");
              ano = year;
            }
          }
          return {
            id: btl.id,
            client_id: btl.client_id,
            importe: btl.total_investment,
            comision: btl.total_commission,
            facturafecha: btl.facturafecha,
            facturanumero: btl.facturanumero,
            facturafechacobro: btl.facturafechacobro,
            mes,
            ano,
            estatus: "100%",
            eliminada: btl.eliminada,
            cliente: allClientes.find((c) => c.id === btl.client_id)?.nombre || "Desconocido",
            type: "BTL",
            moneda_dolar: btl.moneda_dolar || false,
            ejecutivo: btl.executive_responsible ? parseInt(btl.executive_responsible, 10) : null,
          };
        });

        const combinedOportunidades = [...mappedOportunidades, ...mappedOportunidadesBTL];
        setTodasOportunidades(combinedOportunidades);
        setIntermediarios(allIntermediarios);
        setClientes(allClientes);
        setUsuarios(allUsuarios);
        const intermediariosUnicos = allIntermediarios
          .map((i) => ({ id: i.id, nombre: i.nombre }))
          .filter((i) => i.nombre)
          .sort((a, b) => a.nombre.localeCompare(b.nombre));
        setIntermediariosUnicos(intermediariosUnicos);
        // Mapear ejecutivos únicos basados en los IDs con ventas al 100%
        const uniqueEjecutivoIds = [...new Set(combinedOportunidades.map((op) => op.ejecutivo).filter((id) => id !== null))];
        const ejecutivosUnicos = uniqueEjecutivoIds
          .map((ejecutivoId) => {
            const usuario = allUsuarios.find((u) => parseInt(u.id, 10) === ejecutivoId);
            return usuario ? { id: ejecutivoId, nombre: usuario.nombre } : null;
          })
          .filter((u) => u !== null)
          .sort((a, b) => a.nombre.localeCompare(b.nombre));
        setEjecutivosUnicos(ejecutivosUnicos);
      } catch (error) {
        console.error("Error al inicializar datos:", error);
        log.error("initialize", error);
        toast.error("Error al cargar los datos iniciales");
      }
    };
    initialize();
  }, [pais]);

  useEffect(() => {
    const filtrarOportunidades = () => {
      const filtradas = todasOportunidades
        .filter((oportunidad) => {
          const fechaFactura = oportunidad.facturafecha ? new Date(oportunidad.facturafecha) : null;
          const mesFactura = fechaFactura ? (fechaFactura.getMonth() + 1).toString().padStart(2, "0") : null;
          const mesOportunidad = oportunidad.mes ? oportunidad.mes.toString().padStart(2, "0") : null;
          const anoFactura = fechaFactura ? fechaFactura.getFullYear() : null;
          const anoOportunidad = oportunidad.ano ? parseInt(oportunidad.ano, 10) : null;
          const mesParaFiltrar = fechaFactura ? mesFactura : mesOportunidad;
          const anoParaFiltrar = fechaFactura ? anoFactura : anoOportunidad;
          const mesFiltrado = filtroMeses.length > 0 ? filtroMeses.includes(mesParaFiltrar) : true;
          const clienteAsociado = clientes.find((c) => c.id === oportunidad.client_id);
          const intermediarioId = clienteAsociado ? clienteAsociado.agencia : null;
          const intermediarioFiltrado = oportunidad.type === "BTL" ? true : (
            filtroIntermediario ? intermediarioId && intermediarioId === parseInt(filtroIntermediario) : true
          );
          const facturadoFiltrado = filtroFacturado
            ? filtroFacturado === "Facturado"
              ? oportunidad.facturanumero && oportunidad.facturanumero.trim() !== ""
              : !oportunidad.facturanumero || oportunidad.facturanumero.trim() === ""
            : true;
          const perteneceAlAno = filtroAnos.length > 0 ? filtroAnos.includes(anoParaFiltrar?.toString()) : true;
          const tipoFiltrado = filtroTipo
            ? (filtroTipo === "BTL" ? oportunidad.type === "BTL" : oportunidad.type !== "BTL")
            : true;
          const ejecutivoFiltrado = filtroEjecutivo
            ? oportunidad.ejecutivo === parseInt(filtroEjecutivo, 10)
            : true;
          return (
            mesFiltrado &&
            intermediarioFiltrado &&
            (filtroNumeroFactura ? oportunidad.facturanumero === filtroNumeroFactura : true) &&
            (filtroCliente ? oportunidad.cliente === filtroCliente : true) &&
            (filtroCobrada
              ? filtroCobrada === "Sí"
                ? oportunidad.facturafechacobro
                : !oportunidad.facturafechacobro
              : true) &&
            facturadoFiltrado &&
            perteneceAlAno &&
            tipoFiltrado &&
            ejecutivoFiltrado &&
            oportunidad.estatus === "100%" &&
            !oportunidad.eliminada
          );
        })
        .map((oportunidad) => {
          let comision = oportunidad.comision;
          let intermediarioNombre = oportunidad.type === "BTL" ? "DIRECTO" : null;
          const ejecutivoAsociado = usuarios.find((u) => parseInt(u.id, 10) === oportunidad.ejecutivo);
          const ejecutivoNombre = ejecutivoAsociado
            ? ejecutivoAsociado.nombre
            : "??";
          if (oportunidad.type !== "BTL") {
            const clienteAsociado = clientes.find((c) => c.id === oportunidad.client_id);
            const intermediarioId = clienteAsociado ? clienteAsociado.agencia : null;
            intermediarioNombre = resolverNombreIntermediario(intermediarioId, intermediarios);
            const anoOportunidad = oportunidad.facturafecha
              ? new Date(oportunidad.facturafecha).getFullYear()
              : oportunidad.ano
                ? parseInt(oportunidad.ano, 10)
                : new Date().getFullYear();
            const intermediarioAsociado = intermediarios.find(
              (i) => i.id === parseInt(intermediarioId)
            );
            if (intermediarioAsociado) {
              if (
                intermediarioAsociado.comision_2 !== null &&
                intermediarioAsociado.comision_2_fechainicio &&
                intermediarioAsociado.comision_2_fechafin
              ) {
                const fechaInicio = new Date(intermediarioAsociado.comision_2_fechainicio);
                const fechaFin = new Date(intermediarioAsociado.comision_2_fechafin);
                const anoInicio = fechaInicio.getFullYear();
                const anoFin = fechaFin.getFullYear();
                comision =
                  anoOportunidad >= anoInicio && anoOportunidad <= anoFin
                    ? intermediarioAsociado.comision_2 || 0
                    : intermediarioAsociado.comision || 0;
              } else {
                comision = intermediarioAsociado.comision || 0;
              }
            }
          }
          return {
            ...oportunidad,
            intermediario: intermediarioNombre,
            comision,
            moneda_dolar: oportunidad.moneda_dolar || false,
            ejecutivoNombre,
            ano: oportunidad.ano ? oportunidad.ano.toString() : new Date().getFullYear().toString(),
          };
        });
      const filtradasOrdenadas = filtradas.sort((a, b) => {
        const fechaA = a.facturafecha ? new Date(a.facturafecha) : new Date(`${a.ano || new Date().getFullYear()}-${a.mes || "01"}-01`);
        const fechaB = b.facturafecha ? new Date(b.facturafecha) : new Date(`${b.ano || new Date().getFullYear()}-${b.mes || "01"}-01`);
        return fechaA - fechaB;
      });
      setOportunidadesFiltradas(filtradasOrdenadas);
      const numerosFactura = [...new Set(filtradasOrdenadas.map((o) => o.facturanumero))]
        .filter(Boolean)
        .sort((a, b) => a.localeCompare(b, undefined, { numeric: true }));
      setNumerosFacturaUnicos(numerosFactura);
      const clientesUnicosList = [...new Set(filtradasOrdenadas.map((o) => o.cliente))].filter(Boolean).sort();
      setClientesUnicos(clientesUnicosList);
    };
    if (todasOportunidades.length > 0 && clientes.length > 0 && intermediarios.length > 0 && usuarios.length > 0) {
      filtrarOportunidades();
    }
  }, [
    filtroMeses,
    filtroNumeroFactura,
    filtroCliente,
    filtroCobrada,
    filtroFacturado,
    filtroAnos,
    filtroIntermediario,
    filtroTipo,
    filtroEjecutivo,
    todasOportunidades,
    intermediarios,
    clientes,
    usuarios,
    resolverNombreIntermediario,
  ]);

  const handleOpenModal = (oportunidad) => {
    setOportunidadEditada(oportunidad);
    setFormData({
      facturanumero: oportunidad.facturanumero || "",
      facturafecha: oportunidad.facturafecha
        ? new Date(oportunidad.facturafecha).toISOString().split("T")[0]
        : "",
      plazocobro: oportunidad.plazocobro
        ? new Date(oportunidad.plazocobro).toISOString().split("T")[0]
        : "",
      facturafechacobro: oportunidad.facturafechacobro
        ? new Date(oportunidad.facturafechacobro).toISOString().split("T")[0]
        : "",
    });
    setShowModal(true);
    setError(null);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setOportunidadEditada(null);
    setFormData({ facturanumero: "", facturafecha: "", facturafechacobro: "" });
    setError(null);
    setLoading(false);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSaveChanges = async () => {
    if (!oportunidadEditada) return;

    // Validaciones
    if (!formData.facturanumero.trim()) {
      setError("El número de factura es obligatorio");
      return;
    }
    if (!formData.facturafecha) {
      setError("La fecha de factura es obligatoria");
      return;
    }

    // Validar que plazocobro >= facturafecha
    if (formData.plazocobro && formData.plazocobro < formData.facturafecha) {
      setError("La fecha proyectada no puede ser anterior a la fecha de factura");
      return;
    }

    // Validar que facturafechacobro >= facturafecha
    if (formData.facturafechacobro && formData.facturafechacobro < formData.facturafecha) {
      setError("La fecha real de cobro no puede ser anterior a la fecha de factura");
      return;
    }

    // Verificar unicidad del número de factura
    const numeroFacturaExistente = todasOportunidades.find(
      (op) =>
        op.facturanumero === formData.facturanumero &&
      op.id !== oportunidadEditada.id
    );
    if (numeroFacturaExistente) {
      setError("El número de factura ya existe");
      return;
    }

    try {
      setLoading(true);

      const updatedOportunidad = {
        facturafecha: formData.facturafecha, // "2025-12-10"
        facturafechacobro: formData.facturafechacobro || null,
        plazocobro: formData.plazocobro || null,
        facturanumero: formData.facturanumero,
        updated_at: new Date().toISOString(),
      };

      await (oportunidadEditada.type === "BTL"
        ? updateOportunidadBTL({ id: oportunidadEditada.id, oportunidad: updatedOportunidad })
        : updateOportunidad({ id: oportunidadEditada.id, oportunidad: updatedOportunidad })
      );

      setTodasOportunidades((prev) =>
        prev.map((op) =>
          op.id === oportunidadEditada.id ? { ...op, ...updatedOportunidad } : op
        )
      );

      toast.success("Factura actualizada correctamente");
      handleCloseModal();
    } catch (error) {
      if (error.code === "23505") {
        setError("El número de factura ya existe");
      } else {
        setError("Hubo un error al actualizar la oportunidad, prueba de nuevo.");
      }
      log.error("handleSaveChanges", error);
    } finally {
      setLoading(false);
    }
  };

  const calcularTotales = () => {
    let totalVenta = 0;
    let totalComision = 0;
    let totalNeto = 0;
    let totalCobrado = 0;

    const hoy = new Date();
    hoy.setHours(0, 0, 0, 0);

    oportunidadesFiltradas.forEach(({
      importe,
      facturafechacobro,
      comision,
      moneda_dolar,
      facturafecha,
    }) => {
      const importeConvertido = getImporteConvertido(importe, pais, moneda_dolar, facturafecha) || 0;
      const comisionValida = typeof comision === "number" && !isNaN(comision) ? comision : 0;

      totalVenta += importeConvertido;
      totalComision += importeConvertido * (comisionValida / 100);

      if (facturafechacobro) {
        const fechaCobro = new Date(facturafechacobro);
        fechaCobro.setHours(0, 0, 0, 0);
        if (fechaCobro <= hoy) {
          totalCobrado += importeConvertido;
        }
      }
    });

    totalNeto = totalVenta - totalComision;

    return { totalVenta, totalComision, totalNeto, totalCobrado };
  };

  const totales = calcularTotales();
  const fecha = { day: "2-digit", month: "2-digit", year: "numeric" };

  if (todasOportunidades.length === 0 || intermediarios.length === 0 || clientes.length === 0 || usuarios.length === 0) return <Loader />;

  const renderMesOptions = () =>
    ["ENE", "FEB", "MAR", "ABR", "MAY", "JUN", "JUL", "AGO", "SEP", "OCT", "NOV", "DIC"].map((mes, index) => (
      <div key={index} className="form-check-facturas" style={{ marginBottom: "5px" }}>
        <input
          className="form-check-input custom-checkbox"
          type="checkbox"
          id={`mes${index}`}
          value={index < 9 ? `0${index + 1}` : `${index + 1}`}
          checked={filtroMeses.includes(index < 9 ? `0${index + 1}` : `${index + 1}`)}
          onChange={(e) => handleMesChange(e.target.value)}
        />
        <label
          className="form-check-label custom-label"
          htmlFor={`mes${index}`}
        >
          {mes}
        </label>
      </div>
    ));

  const handleMesChange = (mes) => {
    setFiltroMeses((prev) =>
      prev.includes(mes) ? prev.filter((item) => item !== mes) : [...prev, mes]
    );
  };

  const renderAnoOptions = () =>
    possibleYears.map((year, index) => (
      <div key={index} className="form-check-facturas" style={{ marginBottom: "5px" }}>
        <input
          className="form-check-input custom-checkbox"
          type="checkbox"
          id={`ano${index}`}
          value={year}
          checked={filtroAnos.includes(year)}
          onChange={(e) => handleAnoChange(e.target.value)}
        />
        <label
          className="form-check-label custom-label"
          htmlFor={`ano${index}`}
        >
          {year}
        </label>
      </div>
    ));

  const handleAnoChange = (ano) => {
    setFiltroAnos((prev) =>
      prev.includes(ano) ? prev.filter((item) => item !== ano) : [...prev, ano]
    );
  };

  // FUNCIÓN SEGURA
  const fechaLocal = (fechaISO) => {
    if (!fechaISO) return null;
    const [y, m, d] = fechaISO.split("-");
    return new Date(y, m - 1, d);
  };

  const hoy = fechaLocal(new Date().toISOString().split("T")[0]);

  const getEstadoCobro = (facturafecha, facturafechacobro, plazocobro) => {
    const fechaCobro = facturafechacobro ? fechaLocal(facturafechacobro) : null;
    const fechaFactura = facturafecha ? fechaLocal(facturafecha) : null;

    // 1. COBRADO Y EN FECHA
    if (fechaCobro && fechaCobro <= hoy) {
      return { bg: "#198754", text: fechaCobro.toLocaleDateString("es-ES", fecha) };
    }

    // 2. COBRADO EN FUTURO → ROJO
    if (fechaCobro && fechaCobro > hoy) {
      return { bg: "#dc3545", text: fechaCobro.toLocaleDateString("es-ES", fecha) };
    }

    // 3. FACTURADO, NO COBRADO → ROJO + fecha factura
    if (fechaFactura) {
      return { bg: "#dc3545", text: fechaFactura.toLocaleDateString("es-ES", fecha) };
    }

    // 4. SIN FACTURAR
    return { bg: "#4c5257", text: "Sin facturar" };
  };

  return (
    <div className="container-facturas-detalle">
      <div className="logo-container mb-4">
        <img src={logo} alt={`${pais} Logo`} className="logo" onClick={() => navigate("/admin")} />
      </div>
      <div className="table-responsive">
        {/* Mini Dashboard */}
        <div className="row justify-content-center mb-3">
          <div className="col-md-2">
            <div className="card text-white" style={{ backgroundColor: "#343a40" }}>
              <div className="card-header text-center" style={{ borderBottom: "1px solid #ffffff" }}>
                BRUTO
              </div>
              <div className="card-body text-center">
                <h5 className="card-title">{`${moneda(pais)} ${totales.totalVenta.toLocaleString(localString(pais), {
                  maximumFractionDigits: decimales(pais),
                  minimumFractionDigits: decimales(pais),
                })}`}</h5>
              </div>
            </div>
          </div>
          <div className="col-md-2">
            <div className="card text-white" style={{ backgroundColor: "#343a40" }}>
              <div className="card-header text-center" style={{ borderBottom: "1px solid #ffffff" }}>
                INTERMEDIACIÓN
              </div>
              <div className="card-body text-center">
                <h5 className="card-title">{`${moneda(pais)} ${totales.totalComision.toLocaleString(localString(pais), {
                  maximumFractionDigits: decimales(pais),
                  minimumFractionDigits: decimales(pais),
                })}`}</h5>
              </div>
            </div>
          </div>
          <div className="col-md-2">
            <div className="card text-white" style={{ backgroundColor: "#343a40" }}>
              <div className="card-header text-center" style={{ borderBottom: "1px solid #ffffff" }}>
                NETO
              </div>
              <div className="card-body text-center">
                <h5 className="card-title">{`${moneda(pais)} ${totales.totalNeto.toLocaleString(localString(pais), {
                  maximumFractionDigits: decimales(pais),
                  minimumFractionDigits: decimales(pais),
                })}`}</h5>
              </div>
            </div>
          </div>
          <div className="col-md-2">
            <div className="card text-white" style={{ backgroundColor: "#343a40" }}>
              <div className="card-header text-center" style={{ borderBottom: "1px solid #ffffff" }}>
                COBRADO
              </div>
              <div className="card-body text-center">
                <h5 className="card-title">{`${moneda(pais)} ${totales.totalCobrado.toLocaleString(localString(pais), {
                  maximumFractionDigits: decimales(pais),
                  minimumFractionDigits: decimales(pais),
                })}`}</h5>
              </div>
            </div>
          </div>
          <div className="col-md-2">
            <div className="card text-white" style={{ backgroundColor: "#343a40" }}>
              <div className="card-header text-center" style={{ borderBottom: "1px solid #ffffff" }}>
                PENDIENTE DE COBRO
              </div>
              <div className="card-body text-center">
                <h5 className="card-title">{`${moneda(pais)} ${(
                  totales.totalVenta - totales.totalCobrado
                ).toLocaleString(localString(pais), {
                  maximumFractionDigits: decimales(pais),
                  minimumFractionDigits: decimales(pais),
                })}`}</h5>
              </div>
            </div>
          </div>
        </div>
        <div className="row justify-content-center mt-2 mb-2">
          <div className="col-md-2">
            <select
              className="form-select"
              value={filtroNumeroFactura}
              onChange={(e) => setFiltroNumeroFactura(e.target.value)}
            >
              <option value="">Número de Factura</option>
              {numerosFacturaUnicos.map((numero) => (
                <option key={numero} value={numero}>{numero}</option>
              ))}
            </select>
          </div>
          <div className="col-md-2">
            <select
              className="form-select"
              value={filtroEjecutivo}
              onChange={(e) => setFiltroEjecutivo(e.target.value)}
            >
              <option value="">Ejecutivo</option>
              {ejecutivosUnicos.map((ejecutivo) => (
                <option key={ejecutivo.id} value={ejecutivo.id}>
                  {ejecutivo.nombre}
                </option>
              ))}
            </select>
          </div>
          <div className="col-md-2">
            <select
              className="form-select"
              value={filtroFacturado}
              onChange={(e) => setFiltroFacturado(e.target.value)}
            >
              <option value="">Facturado</option>
              <option value="Facturado">Facturado</option>
              <option value="Sin facturar">Sin facturar</option>
            </select>
          </div>
          <div className="col-md-2">
            <select
              className="form-select"
              value={filtroCliente}
              onChange={(e) => setFiltroCliente(e.target.value)}
            >
              <option value="">Cliente Publicitario</option>
              {clientesUnicos.map((cliente) => (
                <option key={cliente} value={cliente}>{cliente}</option>
              ))}
            </select>
          </div>
          <div className="col-md-2">
            <Dropdown>
              <Dropdown.Toggle
                variant="white border"
                id="dropdown-mes"
                className={`form-control text-start ${filtroMeses.length > 0 ? "active-filter" : ""}`}
              >
                {filtroMeses.length > 0 ? filtroMeses.map((mes) => mesEnLetras(mes)).join(", ") : "Mes/meses"}
              </Dropdown.Toggle>
              <Dropdown.Menu style={{ maxHeight: "370px", overflowY: "auto" }}>
                {renderMesOptions()}
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </div>
        <div className="row justify-content-center mb-4">
          <div className="col-md-2">
            <select
              className="form-select"
              value={filtroIntermediario}
              onChange={(e) => setFiltroIntermediario(e.target.value)}
            >
              <option value="">Intermediario</option>
              {intermediariosUnicos.map((intermediario) => (
                <option key={intermediario.id} value={intermediario.id}>
                  {intermediario.nombre}
                </option>
              ))}
            </select>
          </div>
          <div className="col-md-2">
            <select
              className="form-select"
              value={filtroTipo}
              onChange={(e) => setFiltroTipo(e.target.value)}
            >
              <option value="">Tipo</option>
              <option value="PAUTA">PAUTA</option>
              <option value="BTL">BTL</option>
            </select>
          </div>
          <div className="col-md-2">
            <Dropdown>
              <Dropdown.Toggle
                variant="white border"
                id="dropdown-anos"
                className={`form-control text-start ${filtroAnos.length > 0 ? "active-filter" : ""}`}
              >
                {filtroAnos.length > 0 ? filtroAnos.join(", ") : "Año/años"}
              </Dropdown.Toggle>
              <Dropdown.Menu>
                {renderAnoOptions()}
              </Dropdown.Menu>
            </Dropdown>
          </div>
          <div className="col-md-2">
            <select
              className="form-select"
              value={filtroCobrada}
              onChange={(e) => setFiltroCobrada(e.target.value)}
            >
              <option value="">Cobrada</option>
              <option value="Sí">Sí</option>
              <option value="No">No</option>
            </select>
          </div>
        </div>
        <table className="table table-hover table-striped">
          <thead className="text-center align-middle">
            <tr>
              <th className="col-status">ID</th>
              <th className="col-tipo">TIPO</th>
              <th className="col-ejecutivo">EJECUTIVO</th>
              <th className="col-fecha-factura">FECHA FACTURA</th>
              <th className="col-numero-factura">NÚMERO FACTURA</th>
              <th className="col-cliente">CLIENTE</th>
              <th className="col-intermediario">INTERMEDIARIO</th>
              <th className="col-venta">VENTA</th>
              <th className="col-comision">COMISIÓN %</th>
              <th className="col-comision">COMISIÓN {moneda(pais)}</th>
              <th className="col-neto">NETO</th>
              <th className="col-cobrada">COBRADA</th>
              <th className="col-editar">EDIT</th>
            </tr>
          </thead>
          <tbody>
            {oportunidadesFiltradas.length === 0 ? (
              <tr>
                <td colSpan="13" className="text-center">
        No hay facturas ni ventas según los filtros seleccionados
                </td>
              </tr>
            ) : (
              oportunidadesFiltradas.map((oportunidad) => {
                const {
                  id,
                  type,
                  ejecutivoNombre,
                  facturafecha,
                  facturanumero,
                  cliente,
                  intermediario,
                  importe,
                  comision,
                  facturafechacobro,
                  plazocobro,
                  mes,
                  ano,
                  moneda_dolar,
                } = oportunidad;

                const estado = getEstadoCobro(facturafecha, facturafechacobro, plazocobro);

                return (
                  <tr key={id}>
                    <td className="col-status bg-success text-white">{id}</td>
                    <td className="col-tipo">{type === "BTL" ? "BTL" : "Pauta"}</td>
                    <td className="col-ejecutivo">{ejecutivoNombre}</td>
                    <td className="col-fecha-factura">
                      {facturafecha ? (
                        <span style={{ color: "black" }}>
                          {fechaLocal(facturafecha).toLocaleDateString("es-ES", fecha)}
                        </span>
                      ) : (
                        <span style={{ color: "red" }}>
                          {mes && ano ? `${mesEnLetras(mes)}/${ano.slice(-2)}` : "-"}
                        </span>
                      )}
                    </td>
                    <td className="col-numero-factura">{facturanumero || "-"}</td>
                    <td className="col-cliente">{cliente}</td>
                    <td className="col-intermediario">{intermediario}</td>
                    <td className="col-venta text-end">
                      {`${moneda(pais)} ${getImporteConvertido(importe, pais, moneda_dolar, facturafecha).toLocaleString(
                        localString(pais),
                        {
                          maximumFractionDigits: decimales(pais),
                          minimumFractionDigits: decimales(pais),
                        }
                      )}`}
                    </td>
                    <td className="col-comision text-center">
                      {(comision || 0).toFixed(1)}%
                    </td>
                    <td className="col-comision text-end">
                      {`${moneda(pais)} ${(getImporteConvertido(importe, pais, moneda_dolar, facturafecha) * (comision / 100)).toLocaleString(
                        localString(pais),
                        {
                          maximumFractionDigits: decimales(pais),
                          minimumFractionDigits: decimales(pais),
                        }
                      )}`}
                    </td>
                    <td className="col-neto text-end">
                      {`${moneda(pais)} ${(getImporteConvertido(importe, pais, moneda_dolar, facturafecha) * (1 - comision / 100)).toLocaleString(
                        localString(pais),
                        {
                          maximumFractionDigits: decimales(pais),
                          minimumFractionDigits: decimales(pais),
                        }
                      )}`}
                    </td>
                    <td
                      className="col-cobrada text-center align-middle"
                      style={{
                        backgroundColor: estado.bg,
                        color: "white",
                        fontWeight: "500",
                      }}
                    >
                      {estado.text}
                    </td>
                    <td className="col-editar text-center align-middle">
                      <FaEdit
                        onClick={() => handleOpenModal(oportunidad)}
                        style={{ cursor: "pointer", fontSize: "1.2em" }}
                      />
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>
      {/* Modal para editar factura */}
      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>Editar Factura</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {error && <div className="alert alert-danger">{error}</div>}
          <Form>
            <Form.Group className="mb-3" controlId="formNumeroFactura">
              <Form.Label>Número de Factura *</Form.Label>
              <Form.Control
                type="text"
                name="facturanumero"
                value={formData.facturanumero}
                onChange={handleInputChange}
                placeholder="Ingrese el número de factura"
                disabled={loading}
                required
              />
            </Form.Group>

            <Form.Group className="mb-3" controlId="formFechaFactura">
              <Form.Label>Fecha de Factura *</Form.Label>
              <Form.Control
                type="date"
                name="facturafecha"
                value={formData.facturafecha}
                onChange={handleInputChange}
                disabled={loading}
                min="2023-01-01"
                max="2050-12-31"
                required
              />
            </Form.Group>

            {/* NUEVO CAMPO */}
            <Form.Group className="mb-3" controlId="formPlazoCobro">
              <Form.Label>Fecha de Cobro Proyectada *</Form.Label>
              <Form.Control
                type="date"
                name="plazocobro"
                value={formData.plazocobro}
                onChange={handleInputChange}
                disabled={loading}
                min={formData.facturafecha || undefined}
                required
              />
            </Form.Group>

            {/* RENOMBRADO */}
            <Form.Group className="mb-3" controlId="formFechaCobroReal">
              <Form.Label>Fecha de Cobro Real</Form.Label>
              <Form.Control
                type="date"
                name="facturafechacobro"
                value={formData.facturafechacobro}
                onChange={handleInputChange}
                disabled={loading}
                min={formData.facturafecha || undefined}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal} disabled={loading}>
      Cancelar
          </Button>
          <Button variant="primary" onClick={handleSaveChanges} disabled={loading}>
            {loading ? "Guardando..." : "Guardar Cambios"}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};